import React from 'react';
import { useSidebarPinState, Page, Header, RoutedTabs } from '@backstage/core-components';
import { attachComponentData, useElementFilter } from '@backstage/core-plugin-api';

const LAYOUT_DATA_KEY = "plugin.user-settings.settingsLayout";
const LAYOUT_ROUTE_DATA_KEY = "plugin.user-settings.settingsLayoutRoute";
const Route = () => null;
attachComponentData(Route, LAYOUT_ROUTE_DATA_KEY, true);
attachComponentData(Route, "core.gatherMountPoints", true);
const SettingsLayout = (props) => {
  const { title, children } = props;
  const { isMobile } = useSidebarPinState();
  const routes = useElementFilter(
    children,
    (elements) => elements.selectByComponentData({
      key: LAYOUT_ROUTE_DATA_KEY,
      withStrictError: "Child of SettingsLayout must be an SettingsLayout.Route"
    }).getElements().map((child) => child.props)
  );
  return /* @__PURE__ */ React.createElement(Page, { themeId: "home" }, !isMobile && /* @__PURE__ */ React.createElement(Header, { title: title ?? "Settings" }), /* @__PURE__ */ React.createElement(RoutedTabs, { routes }));
};
attachComponentData(SettingsLayout, LAYOUT_DATA_KEY, true);
SettingsLayout.Route = Route;

export { LAYOUT_DATA_KEY, LAYOUT_ROUTE_DATA_KEY, SettingsLayout };
//# sourceMappingURL=SettingsLayout.esm.js.map
